<div class="devis-page">
  <div
    class="devis-page__bg"
    *ngIf="backgroundUrl && !isSubProductView"
    [style.background-image]="'url(' + backgroundUrl + ')'"
    aria-hidden="true"></div>
  <div class="devis-page__veil" *ngIf="!isSubProductView" aria-hidden="true"></div>

  <div class="devis-page__inner">
    <header class="devis-page__head" *ngIf="isSubProductView">
      <button type="button" class="devis-page__back" (click)="goBack()" aria-label="Retour">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h1>{{ pageTitle }}</h1>
    </header>

    <div class="devis-page__brand" *ngIf="!isSubProductView">
      <div class="devis-page__logo-wrap">
        <img
          class="devis-page__logo"
          [src]="logoUrl"
          alt="Logo"
          (error)="onLogoError($event)" />
      </div>
      <h1>Devis</h1>
      <p>Choisissez un produit pour estimer votre prime.</p>
    </div>

    <div class="devis-page__state" *ngIf="loading">
      <mat-spinner diameter="36"></mat-spinner>
      <p>Chargement des produits…</p>
    </div>

    <div class="devis-page__state devis-page__state--error" *ngIf="!loading && errorMessage && !cards.length">
      <p>{{ errorMessage }}</p>
      <button type="button" mat-stroked-button color="primary" (click)="load()">Réessayer</button>
    </div>

    <div class="devis-list" *ngIf="!loading && cards.length">
      <button
        type="button"
        class="devis-card"
        *ngFor="let card of cards; trackBy: trackByCardId"
        (click)="onCardClick(card)">
        <span class="devis-card__stripe" [style.background]="card.accentColor" aria-hidden="true"></span>
        <span class="devis-card__avatar">
          <img
            [src]="card.imageUrl"
            [alt]="card.name"
            loading="lazy"
            referrerpolicy="no-referrer"
            (error)="onCardImageError($event)" />
        </span>
        <span class="devis-card__body">
          <strong>{{ card.name }}</strong>
          <small *ngIf="card.description">{{ card.description }}</small>
        </span>
        <span class="devis-card__chevron" aria-hidden="true">
          <mat-icon>chevron_right</mat-icon>
        </span>
      </button>
    </div>
  </div>

  <div class="devis-toast" *ngIf="toastMessage" role="status">
    <mat-icon>error</mat-icon>
    <div>
      <strong>Erreur</strong>
      <p>{{ toastMessage }}</p>
    </div>
  </div>
</div>
